import {
  List,
  Datagrid,
  TextField,
  EmailField,
  FunctionField,
  EditButton,
  BulkDeleteButton,
  usePermissions,
} from "react-admin";
import { Box, Typography } from "@mui/material";

export const RolePermissionList = () => (
  <>
    <List title="Role Permissions">
       <Box sx={{ pt: 5, pb: 5 }}>
        <Typography variant="h4" fontWeight={600} align="left">
          Role Permissions
        </Typography>
      </Box>
      <Datagrid bulkActionButtons={<BulkDeleteButton /> }>
        <TextField source="id" />
        <TextField source="role_name" />
        <TextField source="permissions" />
         <EditButton />
      </Datagrid>
    </List>
  </>
);